import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './HeadingBlock.module.scss'

interface HeadingBlock extends BaseComponentProps {
    swipeable?: boolean
}

export const HeadingBlock: React.ComponentType<BaseComponentProps & {swipable?: boolean}> = props => {
    const className = extractClassNamesFromProps(props, st.headingBlock)
    const heading = <div className={className}>{props.children}</div>

    if (props.swipable) {
        return <div className={st.swipableHeadingBlockContainer}>{heading}</div>
    }

    return heading
}

// Add displayName to preserve the component name on snapshot testing
HeadingBlock.displayName = 'HeadingBlock'
